export const currentDomainUrl = (path = '') => `${document.location.origin}${path}`
